// import {DOMElement} from "react";
import navigation_autoHideOnScreenSize from "../../../../core/model2/navigation/actions/auto-hide-on-screen-size";

// const debug = "navigation_autoHideToMoreHorizontal"
const debug = false

export default function navigation_autoHideToMoreHorizontal() {

    // we cannot just use HTML value ... becuase on window resize neadekvat izza proishodyachego ...


    // const navigationPanelDom = document.getElementsByClassName('ui-navigation')[0] as any
    // const panelHeight = navigationPanelDom.offsetHeight
    //
    // const topNode = navigationPanelDom.getElementsByClassName('top-container')[0]
    // const bottomNode = navigationPanelDom.getElementsByClassName('bottom')[0]
    //
    // const topHeight = topNode.offsetHeight
    // const bottomHeight = bottomNode.offsetHeight

    // Experimental based on js calculations
    const panelWidth    = gd.layout.width
    const leftWidth     = gd.navigationStructure.leftSectionsTotalWidth
    const rightWidth    = gd.navigationStructure.rightSectionsTotalWidth


    debug && console.log(debug, "panel=", panelWidth, "left=", leftWidth, "right=", rightWidth)

    let widthMissing = 0

    const filledWidth = leftWidth + rightWidth
    if (panelWidth < filledWidth) {
        widthMissing = filledWidth - panelWidth
    }

    debug && console.log(debug, "missing width = ", widthMissing)
    navigation_autoHideOnScreenSize(widthMissing, 'width')

    // if (widthMissing > 0) {
    //
    //     debug && console.log(debug, "missing width = ", widthMissing)
    //
    //     navigation_autoHideOnScreenSize(widthMissing)
    //     return true
    //
    // }

    return false

}
